const colorPerThreshold = {
    saturation: '#2E75B6',
    comfort: '#80CE9E',
    vigilance: '#FBAF05',
    stress: '#FC7E7E'
};
/**
 * this is used to make gradient in drop
 */
const endColorPerThreshold = {
    saturation: '#3DB8DE',
    comfort: '#BDE4C0',
    vigilance: '#FED170',
    stress: '#FAADA5'
};
export const thresholdColorScale = (flag) => colorPerThreshold[flag];
export const endcolorScale = (flag) => endColorPerThreshold[flag];
export const colorScales = [
    (id) => ['#61B980', '#419A60', '#207C41', '#005D21'][id % 4], // green
    (id) => ['#C896E7', '#A566CD', '#8336B2', '#600698'][id % 4], // purple
    (id) => ['#E89797', '#CC6666', '#B03434', '#940303'][id % 4], // red
    (id) => ['#4884E5', '#3A64D0', '#2D44BB', '#110391'][id % 4], // blue
    (id) => ['#F4AA8F', '#ED8660', '#E56232', '#DE3E03'][id % 4], // orange
    (id) => ['#FBEB00', '#FDF357', '#FEF782', '#FFFAAD'][id % 4] // yellow
];
export const plotThresholdsPreviewDomainOverrides = {
    HPOT: [0, 200],
    U_CAPA: [0, 100]
};
